import Vue from 'vue'

const state = () => ({
  organization: null,
  doctors: null,
  patientsFollowUpReminders: null,
  patientsRecentlyViewed: null,
  openChatsCount: null,
  openSurveysCount: null,
  protocolEndingsCount: null,
  leadsCount: null,
  settingFilters: null
})

const getters = {}

const actions = {
  async getCurrentOrganizationProfile ({ commit }) {
    const result = await Vue.$http.get('/Organization/Profile')
    if (result?.status === 200) {
      commit('SET_DATA', ['organization', result.data])
    }
  },

  async updateCurrentOrganizationProfile ({ commit }, params) {
    const { doctor, organization } = params
    const result = await Vue.$http.put('/Organization/Profile/Update', { doctor, organization })
    if (result?.status === 200) {
      commit('SET_DATA', ['organization', result.data])
      return result?.data
    }
  },
  async updateOrganization ({ _ }, params) {
    const { id } = params
    const result = await Vue.$http.put(`/Organization/${id}/Update`, { ...params })
    if (result?.staus === 200) {
      console.log(params)
      console.log(result)
    }
  },
  async inviteDoctor ({ commit }, params) {
    const result = await Vue.$http.post('/organization/InviteDoctor', { ...params })
    if (result?.status === 200) {
      console.log(`Respons: The user is registerd; Status: ${result?.status}`)
      // router.push('/').catch(() => {})
    }
    return result?.data
  },
  async invitePatientToThePortal ({ _ }, params) {
    const result = await Vue.$http.post(`/Organization/InvitePatient?id=${params.patientId}&notes=${params.notes}`)
    if (result?.status === 200) {
      console.log(`Respons: The user is registerd; Status: ${result?.status}`)
      // router.push('/').catch(() => {})
    }
    return result?.data
  },
  async getListOfDoctors ({ commit }) {
    const result = await Vue.$http.get('/Organization/Doctors')
    if (result?.status === 200) {
      commit('SET_DATA', ['doctors', result.data])
    }
  },
  async onActivateDoctor ({ _ }, params) {
    const { id } = params
    const result = await Vue.$http.post(`/Doctors/${id}/Activate`)
    if (result?.status === 200) {
      console.log(`Respons: The user is registerd; Status: ${result?.status}`)
      return true
      // router.push('/').catch(() => {})
    }
    return result?.data
  },
  async onDeactivateDoctor ({ _ }, params) {
    const { id } = params
    const result = await Vue.$http.post(`/Doctors/${id}/Deactivate`)
    if (result?.status === 200) {
      console.log(`Respons: The user is registerd; Status: ${result?.status}`)
      return true
      // router.push('/').catch(() => {})
    }
    return result?.data
  },
  async onResendInvitationDoctor ({ _ }, params) {
    const { id } = params
    const result = await Vue.$http.post(`/Doctors/${id}/ResendInvitation`)
    if (result?.status === 200) {
      console.log(`Respons: The user is registerd; Status: ${result?.status}`)
      // router.push('/').catch(() => {})
    }
    return result?.data
  },
  async onResetPassword ({ _ }, id) {
    const result = await Vue.$http.post(`/Doctors/${id}/ResetPassword`)
    if (result?.status === 200) {
      console.log(`Respons: The user is registerd; Status: ${result?.status}`)
      // router.push('/').catch(() => {})
    }
  },
  async getPatientsFollowUpReminders ({ commit }) {
    const result = await Vue.$http.get('/Doctors/dashboard/follow-up-reminders')
    if (result?.status === 200) {
      commit('SET_DATA', ['patientsFollowUpReminders', result.data])
    }
  },
  async getPatientsRecentlyViewed ({ commit }) {
    const result = await Vue.$http.get('/Doctors/dashboard/recently-viewed')
    if (result?.status === 200) {
      commit('SET_DATA', ['patientsRecentlyViewed', result.data])
    }
  },
  async getOpenChatsCount ({ commit }) {
    const result = await Vue.$http.get('/Doctors/dashboard/open-chats-count')
    if (result?.status === 200) {
      commit('SET_DATA', ['openChatsCount', result.data])
    }
  },
  async getOpenSurveysCount ({ commit }) {
    const result = await Vue.$http.get('/Doctors/dashboard/open-surveys-count')
    if (result?.status === 200) {
      commit('SET_DATA', ['openSurveysCount', result.data])
    }
  },
  async getProtocolEndingsCount ({ commit }) {
    const result = await Vue.$http.get('/Doctors/dashboard/protocol-endings-count')
    if (result?.status === 200) {
      commit('SET_DATA', ['protocolEndingsCount', result.data])
    }
  },
  async getLeadsCount ({ commit }) {
    const result = await Vue.$http.get('/Doctors/dashboard/leads-count')
    if (result?.status === 200) {
      commit('SET_DATA', ['leadsCount', result.data])
    }
  },
  async getSettingFilters ({ commit }) {
    const result = await Vue.$http.get('/Organization/Settings')
    if (result?.status === 200) {
      commit('SET_DATA', ['settingFilters', result.data])
      return true
    }
  },
  async updateSettingFilters ({ commit }, params) {
    const result = await Vue.$http.put('/Organization/Settings', { ...params })
    if (result?.status === 200) {
      return true
    }
  }
}

const mutations = {
  SET_DATA: (state, payload) => {
    const [property, value] = payload
    Vue.set(state, property, value)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
